import { render, staticRenderFns } from "./uploadExcel.vue?vue&type=template&id=2845d1ed&scoped=true"
import script from "./uploadExcel.vue?vue&type=script&lang=js"
export * from "./uploadExcel.vue?vue&type=script&lang=js"
import style0 from "./uploadExcel.vue?vue&type=style&index=0&id=2845d1ed&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2845d1ed",
  null
  
)

export default component.exports